import {ReactElement, ReactNode} from "react";

import './MessagePanel.css';
import {MessagePanelType} from "./MessagePanelType";

/**
 * Props for this component
 */
interface MessagePanelProps {
  title: string;
  children?: ReactNode,
  panelType?: MessagePanelType
}

/**
 * This component will show a message panel to provide the user with more information. To use this component please pass
 * the following props:
 *
 * @param title The title of the message panel
 * @param children <i>Optional</i> This will be the body of the message panel. Simple add a body to this tag.
 * @param panelType <i>Optional</i> This parameter defines the styling of the panel. Pass a value in {@link MessagePanelType}.
 * If none passed it will default to {@link MessagePanelType.INFO}
 */
export default function MessagePanel({title, children, panelType}: MessagePanelProps): ReactElement {
  /*
   * This will be used to give each instance of this component a unique ID based on its title. It will replace spaces
   * with _
   */
  const componentTitleForId = `_${title.toLowerCase().replace(' ', '_')}`;

  // Make sure we default to INFO if no value is passed
  if (!panelType) {
    panelType = MessagePanelType.INFO;
  }

  return <div id={`messagePanel${componentTitleForId}`} className={`messagePanel ${panelType}`}>
    <h1 id={`messagePanelTitle${componentTitleForId}`} className={`title`}>{title}</h1>
    {children ? <div id={`messagePanel${componentTitleForId}`} className={`body`}>{children}</div> : <></>}
  </div>;
}